export default {
  masks: {
    weekdays: "WWW",
    input: "DD/MM/YYYY",
    inputDateTime24hr: "DD/MM/YYYY HH:mm"
  },
  theme: {
    container: null,
    navPopoverContainer: { light: null },
    navTitle: { light: null },
    navArrows: { light: null },
    navCell: { light: "vc-nav-cell" },
    navCellActive: { light: "vc-nav-cell-active" },
    navCellInactiveCurrent: { light: "vc-nav-cell-inactive-current" },
    title: { light: null },
    arrows: { light: null },
    weekdays: { light: null },
    dayNotInMonth: "day-not-in-month",
    dayContent: null,
    dayContentDisabled: { light: "vc-day-disabled" }
  },
  modelConfig: {
    type: "string"
  }
};
